import type { Http } from '../http';
import { endpoints } from '../endpoints';
import type { RawRtusResponse, RawRtuResponseWrapper } from '../types/rtu';
import type { RequestOptions } from '../types/common';

export function createRtuApi(http: Http) {
  return {
    async list(options?: RequestOptions): Promise<RawRtusResponse> {
      const res = await http.get<RawRtusResponse>(endpoints.rtu.base, {
        signal: options?.signal,
      });
      return res.data;
    },

    async detail(rtuId: number, options?: RequestOptions): Promise<RawRtuResponseWrapper> {
      const res = await http.get<RawRtuResponseWrapper>(endpoints.rtu.byId(rtuId), {
        signal: options?.signal,
      });
      return res.data;
    },

    async byPlant(plantId: number, options?: RequestOptions): Promise<RawRtusResponse> {
      const res = await http.get<RawRtusResponse>(endpoints.rtu.byPlant(plantId), {
        signal: options?.signal,
      });
      return res.data;
    },
  };
}
